import { create } from 'zustand';
import { getIntegrations } from '../../../api/api';

export const useIntegrationsStore = create((set, get) => ({
  data: null,
  isLoading: true,
  error: null,
  total: 0,

  isModalOpen: false,
  selectedIntegration: null,

  openModal: (integration) => {
    set({
      isModalOpen: true,
      selectedIntegration: integration,
    });
  },

  closeModal: () => {
    set({
      isModalOpen: false,
      selectedIntegration: null,
    });
  },

  fetchIntegrations: async () => {
    set({ isLoading: true, error: null });

    await getIntegrations({
      dataCb: (data) => {
        set({ data, isLoading: false });
      },
      errCb: (err) => {
        set({ error: err, isLoading: false });
      },
    });
  },
}));
